export const gitCommit = '53517db7'
